export const getWordCount = (text: string): number => {
  const trimmedText = text.trim()
  return trimmedText === '' ? 0 : trimmedText.split(/\s+/g).length
}

export const formatWordCount = (count: number) =>
  count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')



// WEBPACK FOOTER //
// ./src/utils/wordCount.ts